// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
import undataList from '@/views/goods/undataList';
import Home from '@/views/goods/Home';
import Datadashboard from '@/views/goods/Datadashboard';

import userGoods from '@/views/goods/userGoods';
import blockDevices from '@/views/goods/blockDevices';

import logoutList from '@/views/goods/logoutList';
import reportList from '@/views/goods/reportList';
import UserList from '@/views/goods/UserList';
import Channelregistration from '@/views/goods/Channelregistration';
import registRation from '@/views/goods/registRation';

import activities from '@/views/Eventmanagement/activities';
import addActivities from '@/views/Eventmanagement/addActivities';
import Eventdetails from '@/views/Eventmanagement/Eventdetails';
import activitiesDetail from '@/views/Eventmanagement/activitiesDetail';
import addMentor from '@/views/Mentor/addMentor';
import appointment from '@/views/Mentor/appointment';
import PhoneOrders from '@/views/Mentor/PhoneOrders';


import Sendrecords from '@/views/adminiStration/Sendrecords';
import AddRole from '@/views/adminiStration/AddRole';
import listRoles from '@/views/adminiStration/listRoles';
import Menupermissions from '@/views/adminiStration/Menupermissions';

import bannerList from '@/views/officialWebsite/bannerList';
import PCcounPewrs from '@/views/officialWebsite/PCcounPewrs';
import PCaddMentor from '@/views/officialWebsite/PCaddMentor';
import PCactivities from '@/views/officialWebsite/PCactivities';
import PCaddActivities from '@/views/officialWebsite/addActivities';
import agreementList from '@/views/officialWebsite/agreementList';





import permissions from '@/views/adminiStration/permissions';

import Allmanagement from '@/views/Ordermanagement/Allmanagement';
import Signissues from '@/views/system/Signissues';

import activeUsers from '@/views/Eventmanagement/activeUsers';








import Machine from '@/views/machine/Machine';

import Littlehousekeeper from '@/views/machine/Littlehousekeeper';
import OpenClubmembership from '@/views/machine/OpenClubmembership';
import vipConfiguration from '@/views/machine/vipConfiguration';
import MachineAisle from '@/views/machine/MachineAisle';
import programControl from '@/views/machine/programControl';


import Order from '@/views/pay/Order';

import girLimg from '@/views/system/girLimg';
import dynamicList from '@/views/system/dynamicList';

import Nicknamereview from '@/views/system/Nicknamereview';
import Authentication from '@/views/system/Authentication';
import Realname from '@/views/system/Realname';
import Degreeauthentication from '@/views/system/Degreeauthentication';
import TrueFaceCertification from '@/views/system/TrueFaceCertification';




// 女头像审核

import AlbumReview from '@/views/system/AlbumReview';
import IntroduceYourself from '@/views/system/IntroduceYourself';
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
import Setevent from '@/views/machine/Setevent';
import addSetevent from '@/views/machine/addSetevent';
import Sweep from '@/views/machine/Sweep';


// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';
// 精彩图集
import counPewrs from '@/views/charts/counPewrs';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    
   
    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/Datadashboard',
            name: '商品管理',
            component: Datadashboard,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/goods/Channelregistration',
            name: '地区注册',
            component: Channelregistration,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/officialWebsite/bannerList',
            name: '商品管理',
            component: bannerList,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/officialWebsite/PCcounPewrs',
            name: 'PC图集列表',
            component: PCcounPewrs,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/officialWebsite/PCaddMentor',
            name: 'PC导师列表',
            component: PCaddMentor,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/officialWebsite/PCactivities',
            name: 'PC活动列表',
            component: PCactivities,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/officialWebsite/addActivities',
            name: 'PC活动列表',
            component: PCaddActivities,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/officialWebsite/agreementList',
            name: '协议列表',
            component: agreementList,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        {
            path: '/goods/registRation',
            name: '渠道注册',
            component: registRation,
            meta: {
                requireAuth: true
            }
        },

        
        {
            path: '/goods/userGoods',
            name: '用户列表',
            component: userGoods,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/blockDevices',
            name: '设备拉黑列表',
            component: blockDevices,
            meta: {
                requireAuth: true
            }
        },

        
        {
            path: '/goods/logoutList',
            name: '注销列表',
            component: logoutList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/reportList',
            name: '举报列表',
            component: reportList,
            meta: {
                requireAuth: true
            }
        },
        
        
        {
            path: '/Eventmanagement/activities',
            name: '活动列表',
            component: activities,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/Eventmanagement/addActivities',
            name: '添加活动',
            component: addActivities,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/Eventmanagement/Eventdetails',
            name: '活动详情',
            component: Eventdetails,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/Eventmanagement/activeUsers',
            name: '活动用户',
            component: activeUsers,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/Eventmanagement/activitiesDetail',
            name: '活动详情',
            component: activitiesDetail,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/Mentor/addMentor',
            name: '添加导师',
            component: addMentor,
            meta: {
                requireAuth: true
            }
        },
        
        
        {
            path: '/Mentor/appointment',
            name: '帮我约她',
            component: appointment,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/Mentor/PhoneOrders',
            name: '电话订单',
            component: PhoneOrders,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/adminiStration/AddRole',
            name: '角色列表',
            component: AddRole,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/adminiStration/listRoles',
            name: '角色列表',
            component: listRoles,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/adminiStration/permissions',
            name: '权限列表',
            component: permissions,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/adminiStration/Menupermissions',
            name: '权限列表',
            component: Menupermissions,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        
        

        
        {
            path: '/Ordermanagement/Allmanagement',
            name: '订单管理',
            component: Allmanagement,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/adminiStration/Sendrecords',
            name: '短信发送记录',
            component: Sendrecords,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/goods/undataList',
            name: '用户列表',
            component: undataList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/Home',
            name: '首页',
            component: Home,
            meta: {
                requireAuth: true
            }
        },
        

        {
            path: '/goods/UserList',
            name: '用户列表',
            component: UserList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/Littlehousekeeper',
            name: '月娘小管家',
            component: Littlehousekeeper,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/OpenClubmembership',
            name: '开通精英Club会员',
            component: OpenClubmembership,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/vipConfiguration',
            name: '会员配置',
            component: vipConfiguration,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        
        {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '男头像审核',
            component: user,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/system/dynamicList',
            name: '动态内容审核',
            component: dynamicList,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/system/girLimg',
            name: '女头像审核',
            component: girLimg,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/Signissues',
            name: '登录遇到问题',
            component: Signissues,
            meta: {
                requireAuth: true
            }
        },
        
         {
            path: '/system/Nicknamereview',
            name: '昵称审核',
            component: Nicknamereview,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/Authentication',
            name: '工作认证',
            component: Authentication,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/system/Realname',
            name: '实名认证',
            component: Realname,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/Degreeauthentication',
            name: '工作认证',
            component: Degreeauthentication,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/TrueFaceCertification',
            name: '真颜认证',
            component: TrueFaceCertification,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        
         {
            path: '/system/AlbumReview',
            name: '相册审核',
            component: AlbumReview,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/IntroduceYourself',
            name: '自我介绍审核',
            component: IntroduceYourself,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/Setevent',
            name: '收到开通活动',
            component: Setevent,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/programControl',
            name: '小程序控制',
            component: programControl,
            meta: {
                requireAuth: true
            }
        },
        
        {
            path: '/machine/addSetevent',
            name: '添加开通活动',
            component: addSetevent,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/Sweep',
            name: '扫一扫',
            component: Sweep,
            meta: {
                requireAuth: true
            }
        },
        
        
        
        
        
        {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化1221',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/counPewrs',
            name: '精彩图集',
            component: counPewrs,
            meta: {
                requireAuth: true
            }
        }
        
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js